import { ComponentConfig } from "@measured/puck";
import WysiwygField from "../../Fields/WysiwygField";
import ButtonBlockRender from "./ButtonBlockRender";

const ButtonBlock: ComponentConfig<{ text: string, buttonText: string, buttonLink: string, targetBlank: boolean, position: 'left' | 'center' | 'right', buttonPosition: false }> = {
    fields: {
        // @ts-ignore
        text: {
            // @ts-ignore
            ...WysiwygField.fields.editor,
            label: 'Tekst nad przyciskiem'
        },
        buttonText: {
            type: 'text',
            label: 'Tekst w przycisku'
        },
        buttonLink: {
            type: 'text',
            label: 'Link przycisku'
        },
        targetBlank: {
            type: 'radio',
            label: 'Link otwiera nową kartę?',
            options: [
                { label: "Tak", value: true },
                { label: "Nie", value: false },
            ],
        },
        buttonPosition: {
            type: 'radio',
            label: 'Przycisk umiejscowiony?',
            options: [
                { label: "U góry", value: true },
                { label: "U dołu", value: false },
            ],
        },
        position: {
            type: 'radio',
            label: 'Położenie',
            options: [
                { label: "Lewo", value: 'left' },
                { label: "Środek", value: 'center' },
                { label: "Prawo", value: 'right' },
            ],
        },
    },
    defaultProps: {
        text: "Przykładowy tekst",
        buttonText: "Przykładowy tekst",
        buttonLink: "/",
        targetBlank: true,
        position: 'left',
        buttonPosition: false,
    },
    render: (props) => (
        <ButtonBlockRender {...props} />
    ),
}

export default ButtonBlock;
